import 'react-dates/lib/css/_datepicker.css';
import 'whatwg-fetch';

require('@babel/polyfill');

require('babel-register'); // global vendor dependencies


window.$ = window.jQuery = require('jquery'); // Bootstrap

require('bootstrap'); // Airbnb date picker


require('react-dates/initialize'); // our styles


require('scss/main.scss'); // router


require('js/app');